<template>
  <div class="video-player">

    <video class="video-js"></video>

    <related-video-list v-if="ended && relatedVideosOptions && relatedVideosOptions.length > 0 "
                        :relatedVideosOptions="relatedVideosOptions"
                        :themeRelatedVideos="'overlay'"></related-video-list>
    <video-information
      v-if=" infoOptions && hasInformations && isDarkSkin &&
            options.controlBarOptions &&
            (!isBo || (isBo && isChapters ))"
      :isBo="isBo"
      :isChapters="isChapters"
      :information="information"
      :player="player"
      :mediaId="+mediaId"
      :statsParams="statsParams"
      :mediaType="mediaType"
      :hasVideoStats="hasVideoStats"
    ></video-information>
  </div>
</template>

<script>
  import VideoInformation from './VideoInformation.vue';
  import RelatedVideoList from './RelatedVideosComponents/RelatedVideoList.vue';
  import {gtagGlobal} from '../GoogleAnalytics/gtpro';
  import axios from 'axios';


  window.videojs = require('video.js');
  videojs = videojs.default || videojs;

  export default {
    name: 'video-player',
    components: {
      VideoInformation,
      RelatedVideoList,
    },
    props: {
      //relatedVideosOptions: Array,
      options: {
        type: Object,
        required: true,
      },
      videoId: {
        type: Number
      },
      start: {
        type: Number,
        default: 0,
      },
      playsinline: {
        type: Boolean,
        default: false,
      },
      customEventName: {
        type: String,
        default: 'statechanged',
      },
      information: {
        type: Object,
        default: function () {
          return {};
        },
      },
      statsOptions: {
        type: Object,
        default: function () {
          return {};
        },
      },
      mediaType: {
        type: String,
      },
      isBo: false,
      isChapters: false,
      is360:false,
      infoOptions:false,
      hasVideoStats:false,

    },
    data() {
      return {
        ended: false,
        callapi: false,
        relatedVideosOptions:[],

      }
    },
    mounted: function () {
      if (!this.player) {
        this.initialize();
      }
      let self = this;
      eventHub.$on('SetMuted', function () {
        self.player.muted(false)
      });

      this.player.on('ended', function () {
        console.log("ended video show relatedVideosOptions if exist")
        self.ended = true
      });



      if(process.env.GA_ID ){
        let source = Object.assign({}, this.options.sources[0]);
        if(Object.keys(Object.assign({}, this.statsOptions).length===0)){
          gtagGlobal(this.player, source, 'Local')

        }else if(this.statsOptions){
          gtagGlobal(this.player, source, 'Global')
        }else if(this.statsOptions===false){
          console.log("this.statsOptions : local pas de GTAG "  )
        }
      }


      this.player.on('play', function () {
        self.ended = false
      });

      if(process.env.API_HOST_GQ && process.env.API_HOST_GQ !== 'null') {
        this.player.on('timeupdate', function () {
          if (self.callapi) return;
          //get currentTime
          var curTime = +self.player.currentTime().toFixed(0);
          var duration = +self.player.duration().toFixed(0);
          let secondsBefore = duration - (duration / 3).toFixed(0);
          //  few seconds before video ends
          if (curTime >= secondsBefore && !self.callapi) {
            self.callapi = true
            self.relatedVideos()
          }
        });
      }


    },
    beforeDestroy: function () {
      if (this.player) {
        this.dispose();
      }
    },
    computed: {
      hasInformations() {
        return this.information && Object.keys(this.information).length > 0 && (
          Object.keys(this.information.primary).length > 0 ||
          Object.keys(this.information.share).length > 0 ||
          Object.keys(this.information.exportOptions).length > 0 ||
          this.information.files.length > 0 ||
          this.information.chapters.length > 0
        );
      },
      isDarkSkin() {
        return this.information && Object.keys(this.information).length > 0;
      },
      mediaId() {
        let id = 0;
        if (this.options) {
          id = this.options[this.mediaType + 'Id'];
        }
        return id;
      },
      statsParams(){
        let videoId=this.options.videoId;
        let client=this.information.client
        return {videoId: videoId,client: client }
      }
    },
    methods: {

      relatedVideos() {
        let self = this;
          console.log("cal api related videos : videoId",self.videoId)
          //var cryptex = this.$route.params.params;
          axios({
            url:   process.env.API_HOST_GQ,
            method: 'post',
            headers: {
              Authorization: 'Bearer ' + process.env.API_TOCKEN,
            },
            data: {
              variables: {id: self.videoId},
              query: `query($id: Int!) {
                      relatedVideo(id: $id) {
                         id
                          title
                          duration
                          url
                          vignette
                          middleVignette
                          miniVignette
                      }
                    }`
            }
          }).then((result) => {
            self.relatedVideosOptions= result.data.data.relatedVideo
            console.log(result);
          })



      },
      initialize: function () {

        // init
        var self = this;
        this.player = null;

        // videojs options
        var videoOptions = Object.assign(
          {
            autoplay: false,
            controls: true,
            preload: 'auto',
            fluid: false,
            muted: false,
            width: '100%',
            height: '360',
            language: 'en',
            controlBar: {
              remainingTimeDisplay: false,
              playToggle: {},
              progressControl: {},
              fullscreenToggle: {},
              volumeMenuButton: {
                inline: false,
                vertical: false
              }
            },
            techOrder: ["hlsjs", "html5", "flash"],
            plugins: {}
          },
          this.options,
        );

        videoOptions.flash = Object.assign({}, videoOptions.flash, {
          swf: process.env.FLASH_SWF_URL || '',
        });

        // check sources
        /*
          if (!videoOptions.sources || !videoOptions.sources.length) {
            console.warn('Missing required option: "sources".')
            return false
          }
          */

        // ios fullscreen
        var playsinline = this.playsinline;
        if (playsinline) {
          this.$el.children[0].setAttribute('playsinline', playsinline);
          this.$el.children[0].setAttribute('webkit-playsinline', playsinline);
        }

        // emit event
        var emitPlayerState = function (event, value) {
          if (event) {
            self.$emit(event, self.player);
          }
          if (value) {
            var values = {};
            values[event] = value;
            self.$emit(self.customEventName, values);
          }
        };

        // videoOptions
        // console.log(videoOptions)

        // avoid error "VIDEOJS: ERROR: Unable to find plugin: __ob__"
        if (videoOptions.plugins) {
          delete videoOptions.plugins.__ob__;
        }

        this.player = videojs(this.$el.children[0], videoOptions, function () {
          // player readied
          var _this = this;
          self.$emit('ready', self.player);

          // events
          var events = [
            'loadeddata',
            'canplay',
            'canplaythrough',
            'play',
            'pause',
            'waiting',
            'playing',
            'ended',
            'error',
          ];
          for (var i = 0; i < events.length; i++) {
            (function (event) {
              _this.on(event, function () {
                emitPlayerState(event, true);
              });
            })(events[i]);
          }

        this.on('timeupdate', function() {
          emitPlayerState('timeupdate', this.currentTime());
        });

        this.on('error', function(e,b) {
          console.log(e);
          console.log(b);
          console.log(_this.error());
          if(_this.error().code == 3)
            eventHub.$emit('playerError', { code: 'error-3', cause: 'source_error' });
        });
      });
      if(this.is360){
        try{
            this.player.el_.getElementsByTagName("video")[0].setAttribute('crossorigin', 'anonymous');
          }
          catch(e){
          console.log("crossOrigin",e)
          }
      }

      let counter = 0;
      let interval = setInterval(() => {
        const infoEl = docShadow.querySelector('.video-info-container');
        if (infoEl) {
          this.player.el().appendChild(infoEl);
        }
        counter++;
        if (infoEl || counter === 100) {
          clearInterval(interval);
        }
      }, 100);
    },
    dispose: function() {
      if (this.player && videojs) {
        if (this.player.techName_ !== 'Flash') {
          this.player.pause && this.player.pause();
        }
        videojs(this.$el.children[0]).dispose();
        if (!this.$el.children.length) {
          var video = document.createElement('video');
          video.className = 'video-js';
          this.$el.appendChild(video);
        }
        this.player = null;
      }
    },
  },
  watch: {
    options: {
      deep: true,
      handler: function(options, oldOptions) {


          if (options && options.sources && options.sources.length && (options.uid !== oldOptions.uid || !!!options.uid)) {
            this.dispose();
            this.initialize();
          }
        },
      },
      relatedVideosOptions: {
        deep: true,
        handler: function (val, oldval) {
          this.relatedVideosOptions = val
        },
      },
      information: {
        deep: true,
        handler: function (val, oldval) {
          this.information = val
        },
      },
    videoId: {
        deep: true,
        handler: function (val, oldval) {
          this.videoId = val
        },
      },
      statsOptions: {
        deep: true,
        handler: function (val, oldval) {

          console.log("deep watcher statsOptions ", val)
          console.log("deep watcher statsOptions process.env.GA_ID ", process.env.GA_ID)

          if(process.env.GA_ID  ){
            let source = Object.assign({}, this.options.sources[0]);
            if(val) {
              gtagGlobal(this.player, source, 'Global')
            }else{
              gtagGlobal(this.player, source, 'Stop')
            }
          }

          this.statsOptions = val
        },
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/VideoPlayer.vue